<template>
  <section>
    <div class="titulo">
      <div class="margem container">
        <div class="m-icone direita">
          <div class="pesquisa">
            <input v-model="filtroNome" @input="pesquisaComFiltro" type="text" placeholder="Pesquisar visitante por nome" />
            <a href="#" class="icone-pesquisa" title="Pesquise" @click.prevent="dispararPesquisaIcone"></a>
          </div>
        </div>
        <h2>Visitantes</h2>
      </div>
    </div>
    <div class="margem container">
      <div class="bloco margem">
        <div class="alinha-direita">
          <router-link to="/visitante/novo"><button class="acao-secundaria">Novo Visitante</button></router-link>
        </div>
        <table class="tabela alinha-centro">
          <thead class="tabela alinha-centro">
            <tr>
              <th>Nome</th>
              <th>CPF</th>
              <th>Celular</th>
              <th>E-mail</th>
              <th>Nova visita</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody class="tabela alinha-centro">
            <tr v-for="item in visitantesFiltrados" :key="item.id">
              <td>{{ item.nomeCompleto }}</td>
              <td>{{ item.CPF || "Não informado" }}</td>
              <td>{{ item.celular || "Não informado" }}</td>
              <td>{{ item.email || "Não informado" }}</td>
              <td>
                <a @click="abrirModal(item)" class="icone-adicionar"></a>
              </td>
              <td>
                <a @click="editarPessoa(item)" class="icone-editar"></a>
                <a @click="excluirPessoa(item.id)" class="icone-lixeira"></a>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <div class="alinha-centro">
          <button @click="buscarTodosVisitantes(page - 1)" :disabled="page === 1">Anterior</button>
          <span style="margin: 2vh">Página {{ page }} de {{ lastPage }}</span>
          <button @click="buscarTodosVisitantes(page + 1)" :disabled="page === lastPage">Próxima</button>
        </div>
      </div>
    </div>

    <!-- MODAL VISITANTE -->
    <div class="modal-mask" v-if="isOpen" @click="fecharModalFora">
      <div class="modal-container modal-visita-grupo">
        <div class="d-flex justify-content-between">
          <h3>Cadastrar visita</h3>
        </div>
        <p class="hint-visita-grupo">
          Os mesmos setores, validade e informações valem para todos. Cada visitante recebe QR e check-in próprios.
        </p>
        <div class="bloco-visitantes-visita">
          <div class="titulo-bloco-modal">Visitantes nesta visita</div>
          <ul class="lista-chips-visitantes">
            <li v-for="v in visitantesNaVisita" :key="'v-' + v.id">
              <span>{{ v.nomeCompleto }}</span>
              <button
                type="button"
                class="btn-remover-visita"
                :disabled="visitantesNaVisita.length <= 1"
                title="Remover da lista"
                @click="removerVisitanteDaVisita(v.id)"
              >
                ×
              </button>
            </li>
          </ul>
          <div class="busca-mais-visitante">
            <label for="buscaVisitanteExtra">Incluir outro visitante</label>
            <input
              id="buscaVisitanteExtra"
              v-model="buscaVisitanteExtra"
              type="text"
              placeholder="Digite o nome (mín. 2 caracteres)"
              autocomplete="off"
              @input="debounceBuscaVisitantesExtra"
            />
            <ul v-if="sugestoesVisitantes.length" class="sugestoes-visitantes">
              <li v-for="s in sugestoesVisitantes" :key="'sug-' + s.id">
                <button type="button" class="btn-sugestao-visitante" @click="adicionarVisitanteNaVisita(s)">
                  {{ s.nomeCompleto }}
                  <span v-if="s.CPF" class="muted"> · {{ s.CPF }}</span>
                </button>
              </li>
            </ul>
            <span v-if="buscandoSugestoesVisita" class="muted">Buscando…</span>
          </div>
        </div>
        <hr />
        <div style="display: flex; flex-flow: column">
          <div style="display: flex; flex-flow: row">
            <div style="width: 45%; display: flex; flex-flow: column; padding: 15px 20px 0px 0px">
              <div style="display: flex; flex-flow: row; margin-bottom: 15px"><span>Validade</span>&nbsp;<span style="color: var(--cor-erro)">*</span></div>
              <div style="display: flex; flex-flow: row">
                <div>
                  <input id="dias" v-model.number="diasVisita" type="number" min="0" size="sm" style="width: 60px" />
                  <label for="dias">Dia(s)</label>
                </div>
                <div>
                  <input id="horas" v-model.number="horasVisita" type="number" min="0" max="24" size="sm" style="width: 60px" />
                  <label for="horas">Hora(s)</label>
                </div>
              </div>
              <div style="display: flex; flex-flow: column; padding-top: 45px">
                <div style="display: flex; flex-flow: row; margin-bottom: 15px">
                  <span>Informações</span>
                </div>
                <div>
                  <textarea v-model="infoVisita" rows="5" placeholder="Digite as informações sobre a visita (Opcional)"></textarea>
                </div>
              </div>
            </div>
            <div style="display: flex; flex-flow: column; padding: 15px 20px 0px 0px">
              <div style="margin-bottom: 15px"><span>Setor</span>&nbsp;<span style="color: var(--cor-erro)">*</span></div>
              <input v-model="filtroSetor" type="text" placeholder="Pesquisar" aria-label="Pesquisa" aria-describedby="basic-addon1" />
              <div class="setores-container">
                <table>
                  <tr v-for="item in setoresFiltrados" :key="item.id">
                    <td>
                      <input v-model="setoresVisitante" type="checkbox" :value="item.id" />
                    </td>
                    <td style="max-height: 40px; overflow-y: auto">&nbsp;&nbsp;{{ item.nome }}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div style="width: 50%; display: flex; flex-flow: column; padding: 15px 0px 0px 0px">
              <div>
                <button type="button" @click="iniciaLeitor"><i class="fa-regular fa-address-card"></i>&nbsp;&nbsp;Vincular QR Code</button>
              </div>
              <br />
              <div class="camera" style="border: solid; border-width: 1px; border-color: var(--color-fonte); border-radius: 10px">
                <qrcode-stream v-if="cameraAberta && !qrcodeWebcam" @decode="onDecode" @init="onInit" />
              </div>
            </div>
          </div>
          <div>
            <button type="button" @click="salvarVisita">
              <i v-if="loading" class="fas fa-spinner fa-spin"></i>
              <span v-if="!loading">&nbsp;Salvar &nbsp;</span>
              <span v-if="loading">&nbsp;Salvando... &nbsp;</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- END MODAL VISITANTE -->

    <!-- MODAL EXCLUIR -->
    <div class="modal-mask" v-if="showModal" @click="fecharModalFora">
      <div class="modal-container" style="height: min-content; width: 50rem">
        <div style="display: flex; justify-content: center"></div>
        <br />
        <div class="modal-body">
          <span>Confirma a exclusão do registro?</span>
          <br /><br />
          <div class="modal-footer">
            <button type="button" @click="confirmarExclusao">Confirmar</button>&nbsp;&nbsp;
            <button type="button" @click="fecharModal" class="acao-secundaria">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END MODAL EXCLUIR -->
</template>

<script>
import { createToaster } from "@meforma/vue-toaster";
import { ref } from "vue";
import WebSocketService from "../../services/websocketservice";
import { QrcodeStream } from "vue-qrcode-reader";

import Setores from "@/models/Setor";
import setorService from "../../services/setor-service";
import visitanteService from "@/services/visitante-service";
import { api } from "roboflex-thalamus-request-handler";
import { sso } from "roboflex-thalamus-sso-lib";

const toaster = createToaster({
  position: "top-right",
});

export default {
  name: "VisitanteView",
  components: {
    QrcodeStream,
  },
  setup() {
    const isOpen = ref(false);
    const openModal = () => {
      isOpen.value = true;
      return isOpen.value;
    };
    return {
      isOpen,
      openModal,
    };
  },
  data() {
    return {
      showModal: false,
      pessoaIDModal: null,
      pessoaNomeModal: null,
      pessoaCPFModal: null,
      pessoaEmail: null,
      filtroNome: "",
      visitantes: [],
      page: 1,
      lastPage: null,
      currentPage: null,
      totalPages: null,
      visitantesFiltrados: [],
      idToDelete: null,
      filtroSetor: "",
      setoresVisitante: [],
      mostraAlerta: false,
      mostraAlertaWebcam: false,
      wsService: new WebSocketService(),
      qrcodeWebcam: null,
      qrcodeCartao: "",
      cameraAberta: false,
      dadosVisitaModal: {},
      qrCodeEmail: "",
      loading: false,
      setores: [],
      debounceTimer: null, // Timer para debounce
      /** Vários visitantes na mesma configuração de visita (setores/validade/info). */
      visitantesNaVisita: [],
      buscaVisitanteExtra: "",
      sugestoesVisitantes: [],
      buscandoSugestoesVisita: false,
      debounceVisitantesExtra: null,
      diasVisita: 1,
      horasVisita: 0,
      infoVisita: "",
    };
  },
  created() {
    const usuarioLogado = sso.getUsuarioLogado();
    this.userName = usuarioLogado.nome; // nome
    this.userId = usuarioLogado.id; // id
    this.local = usuarioLogado.local;
    this.obterSetores();
  },
  mounted() {
    this.buscarTodosVisitantes(1);
    this.buscaLocal();
  },
  beforeUnmount() {
    this.wsService.removeListener(this.handleMessage);
    this.wsService.close();
  },
  computed: {
    setoresFiltrados() {
      return this.setores.filter((setor) => {
        const buscaSetor = this.filtroSetor.toLowerCase();
        return setor.nome && setor.nome.toLowerCase().includes(buscaSetor);
      });
    },
  },
  methods: {
    adicionarPessoa() {
      this.$router.push({ name: "VisitanteCadastro" });
    },
    editarPessoa(pessoa) {
      this.$router.push({ name: "EditarVisitante", params: { id: pessoa.id } });
    },
    excluirPessoa(id) {
      this.idToDelete = id;
      this.showModal = true;
    },
    confirmarExclusao() {
      const id = this.idToDelete;
      const index = this.visitantes.findIndex((item) => item.id === id);
      if (index !== -1) {
        api
          .delete(`visitante/${id}`)
          .then((response) => {
            console.log("Response", response);
            this.buscarTodosVisitantes(this.page);
            this.showModal = false;
          })
          .catch((error) => {
            console.error(`Error`, error);
            toaster.show(`Erro. Não foi possível excluir o visitante`, { type: "error" });
          });
      }
      toaster.show(`Visitante excluído`, { type: "success" });
    },
    fecharModal() {
      this.isOpen = false;
      this.showModal = false;
      this.resetModalVisita();
    },
    resetModalVisita() {
      this.visitantesNaVisita = [];
      this.buscaVisitanteExtra = "";
      this.sugestoesVisitantes = [];
      this.diasVisita = 1;
      this.horasVisita = 0;
      this.infoVisita = "";
      this.setoresVisitante = [];
      this.qrCodeCartao = "";
      this.cameraAberta = false;
    },
    removerVisitanteDaVisita(id) {
      if (this.visitantesNaVisita.length <= 1) return;
      this.visitantesNaVisita = this.visitantesNaVisita.filter((v) => v.id !== id);
    },
    adicionarVisitanteNaVisita(pessoa) {
      if (!pessoa || !pessoa.id) return;
      if (this.visitantesNaVisita.some((v) => v.id === pessoa.id)) {
        toaster.show("Este visitante já está na lista.", { type: "warning" });
        return;
      }
      this.visitantesNaVisita.push({
        id: pessoa.id,
        nomeCompleto: pessoa.nomeCompleto,
        email: pessoa.email || "",
        CPF: pessoa.CPF || pessoa.documentoRgCnh || "",
      });
      this.buscaVisitanteExtra = "";
      this.sugestoesVisitantes = [];
    },
    debounceBuscaVisitantesExtra() {
      clearTimeout(this.debounceVisitantesExtra);
      this.debounceVisitantesExtra = setTimeout(() => this.buscarSugestoesVisitantesExtra(), 400);
    },
    async buscarSugestoesVisitantesExtra() {
      const q = String(this.buscaVisitanteExtra || "").trim();
      if (q.length < 2) {
        this.sugestoesVisitantes = [];
        return;
      }
      this.buscandoSugestoesVisita = true;
      try {
        const lista = await visitanteService.buscarPorNome(q);
        const idsJa = new Set(this.visitantesNaVisita.map((v) => v.id));
        this.sugestoesVisitantes = (lista || []).filter((x) => x.id && !idsJa.has(x.id)).slice(0, 15);
      } catch (e) {
        console.error(e);
        this.sugestoesVisitantes = [];
      } finally {
        this.buscandoSugestoesVisita = false;
      }
    },
    ordenarPessoas(a, b) {
      return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
    },
    async buscarTodosVisitantes(page = 1) {
      if (page < 1 || (this.lastPage != null && page > this.lastPage)) return;

      try {
        const res = await visitanteService.listarTodos({
          page,
          search: this.filtroNome ? String(this.filtroNome).trim() : "",
        });
        const rows = Array.isArray(res.data) ? res.data : [];
        this.visitantes = rows;
        this.page = res.current_page ?? page;
        this.lastPage = res.last_page ?? 1;
        this.visitantesFiltrados = [...rows];
      } catch (error) {
        console.error("Erro ao buscar visitantes:", error);
        this.visitantes = [];
        this.visitantesFiltrados = [];
        this.lastPage = 1;
        toaster.show("Não foi possível carregar os visitantes. Tente novamente.", { type: "error" });
      }
    },
    pesquisaComFiltro() {
      clearTimeout(this.debounceTimer); // Cancela qualquer chamada pendente

      this.debounceTimer = setTimeout(() => {
        if (!this.filtroNome.trim()) {
          // Se o campo de pesquisa for apagado, volta ao estado original
          this.buscarTodosVisitantes(1);
        } else {
          this.buscarTodosVisitantes(1);
        }
      }, 500);
    },

    dispararPesquisaIcone() {
      clearTimeout(this.debounceTimer);
      this.buscarTodosVisitantes(1);
    },

    mostraGenero(generoAbreviado) {
      if (generoAbreviado === "f") {
        return "Feminino";
      } else if (generoAbreviado === "m") {
        return "Masculino";
      } else {
        return generoAbreviado;
      }
    },
    abrirModal(pessoa) {
      this.pessoaIDModal = pessoa.id;
      this.pessoaNomeModal = pessoa.nomeCompleto;
      this.pessoaCPFModal = pessoa.CPF;
      this.pessoaEmail = pessoa.email;
      this.visitantesNaVisita = [
        {
          id: pessoa.id,
          nomeCompleto: pessoa.nomeCompleto,
          email: pessoa.email || "",
          CPF: pessoa.CPF || "",
        },
      ];
      this.buscaVisitanteExtra = "";
      this.sugestoesVisitantes = [];
      this.diasVisita = 1;
      this.horasVisita = 0;
      this.infoVisita = "";
      this.setoresVisitante = [];
      this.qrCodeCartao = "";
      this.cameraAberta = false;
      this.isOpen = true;
    },
    fecharModalFora(event) {
      if (event.target === event.currentTarget) {
        this.fecharModal();
      }
    },
    async buscaLocal() {
      try {
        const response = await api.get(`/local`);
        this.localData = response.data;
      } catch (error) {
        console.error("Error:", error);
      }
    },
    async alterarLocal() {
      if (this.localSelecionado !== null) {
        try {
          const response = await api.get(`/local/${this.localSelecionado}/acessos-hoje`);
          this.localData = response.data || [];
        } catch (error) {
          console.error("Error", error);
        }
      }
    },
    obterSetores() {
      setorService
        .obterTodos()
        .then((response) => {
          this.setores = response.data.map((p) => new Setores(p));
        })
        .catch((error) => {
          console.log(error);
          toaster.show(`Erro ao carregar lista de setores"`, { type: "error" });
        });
    },
    iniciaLeitor() {
      this.wsService.addListener(this.handleMessage);

      const chamaLeitorQrcode = JSON.stringify({
        mensagem: "iniciar_leitor",
        local_id: this.local,
      });

      this.wsService.send(chamaLeitorQrcode);

      console.log("chamando websocket...", chamaLeitorQrcode);

      const timeout = 2000;
      const timeoutId = setTimeout(() => {
        console.log("tablet não respondeu, chamando webcam...");
        this.wsService.removeListener(this.handleMessage);
        this.iniciarLeituraWebcam();
      }, timeout);

      this.wsService.addListener(() => {
        clearTimeout(timeoutId);
        this.wsService.removeListener(this.handleMessage);
      });

      this.qrCodeCartao = "";
      this.mostraAlerta = false;
    },
    handleMessage(event) {
      try {
        if (event && event.data) {
          const message = event.data;
          const messageData = JSON.parse(message);
          if (messageData.mensagem === "qr_capturado") {
            this.qrCodeCartao = messageData.qrcode;
            console.log("leu no tablet:", this.qrCodeCartao);
            this.mostraAlerta = true;
            toaster.show(`Qr code capturado`, { type: "success" });
            return;
          }
        } else {
          console.log("Sem resposta do websocket");
        }
      } catch (error) {
        console.error(error);
      }
    },
    iniciarLeituraWebcam() {
      if (this.cameraPermissaoConcedida()) {
        this.cameraAberta = true;
      } else {
        console.log("Permissão para a webcam não concedida");
        toaster.show(`Por favor, conceda permissão para acessar a webcam`, { type: "error" });
      }
    },
    cameraPermissaoConcedida() {
      return navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
    },
    vincularCartaoWebcam() {
      this.onDetect();
    },
    async onDecode(result) {
      try {
        this.qrCodeCartao = "";
        this.mostraAlerta = false;
        console.log("tem qr code?", this.qrCodeCartao);
        this.qrCodeCartao = result;
        console.log("lido na webcam:", this.qrCodeCartao);
        this.cameraAberta = false;
        toaster.show(`Qr code capturado`, { type: "success" });
      } catch (error) {
        console.error("Erro onDecode: ", error);
      }
    },
    async onInit(promise) {
      try {
        await promise;
        console.log("oninit ", promise);
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permission";
          console.log(this.error);
          toaster.show(`Sem permissão para acessar a webcam`, { type: "error" });
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
          console.log(this.error);
          toaster.show(`Webcam não encontrada`, { type: "error" });
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
          console.log(this.error);
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
          console.log(this.error);
          toaster.show(`Webcam está em uso`, { type: "error" });
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
          console.log(this.error);
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
          console.log(this.error);
        }
      }
    },
    montarQrcodeVisita(pessoaID, pessoaNome, sufixoUnico) {
      const dataCapturada = new Date();
      const dataFormatada = dataCapturada
        .toLocaleString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .replace(/[^\d]/g, "");
      return (
        "VX" +
        pessoaID +
        String(pessoaNome || "").replace(/\s/g, "") +
        this.setoresVisitante.join("") +
        this.local +
        dataFormatada +
        String(sufixoUnico || "")
      );
    },

    async salvarVisita() {
      this.loading = true;

      const lista = Array.isArray(this.visitantesNaVisita) ? this.visitantesNaVisita : [];
      if (lista.length === 0) {
        toaster.show("Inclua ao menos um visitante.", { type: "error" });
        this.loading = false;
        return;
      }

      if (this.setoresVisitante.length === 0) {
        toaster.show(`Selecione um setor para a visita.`, { type: "error" });
        this.loading = false;
        return;
      }

      const dias = Number(this.diasVisita);
      const horas = Number(this.horasVisita);
      if ((!horas || horas <= 0) && (!dias || dias <= 0)) {
        toaster.show(`Informe a validade da visita`, { type: "error" });
        this.loading = false;
        return;
      }

      const varios = lista.length > 1;

      if (varios) {
        const semEmail = lista.filter((v) => !String(v.email || "").trim());
        if (semEmail.length) {
          toaster.show(
            "Para cadastrar vários visitantes na mesma visita, cada um precisa ter e-mail cadastrado (QR enviado individualmente).",
            { type: "error" }
          );
          this.loading = false;
          return;
        }
        if (this.qrCodeCartao) {
          toaster.show(
            "Com vários visitantes, o QR físico lido não é aplicado; cada visitante recebe o QR por e-mail.",
            { type: "warning" }
          );
        }
      } else {
        const pessoaEmail = lista[0].email;
        if (!String(pessoaEmail || "").trim() && !this.qrCodeCartao) {
          toaster.show(`Informe o e-mail ou leia um QR Code para a visita.`, { type: "error" });
          this.loading = false;
          return;
        }
      }

      let ok = 0;
      let falhou = false;

      try {
        for (let i = 0; i < lista.length; i++) {
          const visitante = lista[i];
          const pessoaID = visitante.id;
          const pessoaNome = visitante.nomeCompleto;
          const sufixo = `${Date.now()}${i}`;
          this.qrCodeEmail = this.montarQrcodeVisita(pessoaID, pessoaNome, sufixo);

          const payload = {
            pessoa_id: pessoaID,
            qrcode: this.qrCodeEmail,
            info: this.infoVisita,
            setor_id: this.setoresVisitante,
            val_dias: dias,
            val_horas: horas,
            local_id: this.local,
            base64: this.pessoaImgBase64,
          };

          if (!varios && this.qrCodeCartao) {
            payload.qrcode_fisico = this.qrCodeCartao;
          }

          const response = await api.post(`/visita`, payload);

          if (response.data?.cod === 1) {
            toaster.show(`QR Code de visitante inválido. Tente outro QR Code`, { type: "error" });
            this.qrCodeCartao = "";
            falhou = true;
            break;
          }
          ok++;
        }

        if (!falhou && ok > 0) {
          if (varios) {
            toaster.show(`${ok} visita(s) cadastrada(s). QR enviado ao e-mail de cada visitante.`, { type: "success" });
          } else {
            const primeiro = lista[0];
            const temEmail = String(primeiro.email || "").trim();
            if (!temEmail && this.qrCodeCartao) {
              toaster.show(`Visita cadastrada`, { type: "success" });
            } else if (temEmail) {
              toaster.show(`Visita cadastrada. QR Code enviado para o e-mail cadastrado`, { type: "success" });
            }
          }
        }

        this.setoresVisitante = [];
        this.qrCodeCartao = "";
        this.cameraAberta = false;
        this.isOpen = false;
        this.resetModalVisita();
      } catch (error) {
        console.error(error);
        toaster.show(`Erro ao cadastrar visita`, { type: "error" });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.setores-container {
  display: flex;
  height: 210px;
  border-radius: 5px;
  border-width: 1px;
  overflow-y: auto;
}

.camera {
  overflow: hidden;
  position: relative;
  height: 250px;
  width: 250px;
}

.modal-visita-grupo .hint-visita-grupo {
  margin: 0 0 0.75rem;
  font-size: 0.92rem;
  color: var(--cor-fonte, #444);
  opacity: 0.95;
}

.bloco-visitantes-visita {
  margin-bottom: 0.5rem;
}

.titulo-bloco-modal {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.lista-chips-visitantes {
  list-style: none;
  padding: 0;
  margin: 0 0 0.75rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.lista-chips-visitantes li {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.6rem;
  background: var(--cor-cinza, #eee);
  border-radius: 6px;
  font-size: 0.9rem;
}

.btn-remover-visita {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 1.2rem;
  line-height: 1;
  padding: 0 0.15rem;
  color: var(--cor-erro, #c00);
}

.btn-remover-visita:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.busca-mais-visitante label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.9rem;
}

.busca-mais-visitante input {
  width: 100%;
  max-width: 420px;
}

.sugestoes-visitantes {
  list-style: none;
  padding: 0;
  margin: 0.35rem 0 0;
  max-height: 180px;
  overflow-y: auto;
  border: 1px solid var(--cor-separador, #ccc);
  border-radius: 6px;
  background: var(--cor-fundo, #fff);
}

.sugestoes-visitantes li + li {
  border-top: 1px solid var(--cor-separador, #eee);
}

.btn-sugestao-visitante {
  display: block;
  width: 100%;
  text-align: left;
  padding: 0.45rem 0.65rem;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-sugestao-visitante:hover {
  background: var(--cor-cinza, #f0f0f0);
}

.muted {
  opacity: 0.75;
  font-size: 0.85rem;
}
</style>
